module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/apisauce/~/axios/index.js
// module id = 860
// module chunks = 0